<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <select class="form-select" [formControl]="formControlObj">
      <option selected value="">
        {{isOptionLoading ? 'Loading..' : 'Select Option'}}
      </option>
      <ng-container *ngFor="let group of optionGroupsFor(optionsObs | async)">
        <optgroup *ngIf="group.heading" [label]="group.heading">
          <option *ngFor="let option of group.options" [value]="option.key">
            {{ option.value }}
          </option>
        </optgroup>
        <ng-container *ngIf="!group.heading">
          <option *ngFor="let option of group.options" [value]="option.key">
            {{ option.value }}
          </option>
        </ng-container>
      </ng-container>
    </select>
  </app-field-title>
</div>